<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { Form } from 'vant'
export default {
  name: 'App',
  data () {
    return {
    }
  },
  mounted () {
    // 创建cnzz统计js
    const script = document.createElement('script')
    script.src = `https://s96.cnzz.com/z_stat.php?id=1277826731&web_id=1277826731`
    script.language = 'JavaScript'
    document.body.appendChild(script)
  },
  watch: {
    '$route': {
      handler (to, from) {
        setTimeout(() => { // 避免首次获取不到window._czc
          if (window._czc) {
            let location = window.location
            let contentUrl = location.pathname + location.hash
            let refererUrl = '/'
            // 用于发送某个URL的PV统计请求，
            window._czc.push(['_trackPageview', contentUrl, refererUrl])
          }
        }, 300)
      },
      immediate: true // 首次进入页面即执行
    }
  }
}
</script>

<style>
html,body, p, ul, ol, dl, h1, h2, h3, h4 {
  margin: 0;
  padding: 0;
}

html, body, #app {
  width: 100%;
  height: 100%;
  max-width: 618px;
  margin: 0 auto;
}

html{
  font-size: 100px;
}

body {
  background-size: cover;
  background-color: #f9f9f9;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #28282a;
  line-height: 21px;
  font-size: 14px;
}

li {
  list-style-type: none;
}

a:-webkit-any-link{
  color: #28282a;
}

* {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue